import { RenewTokenModal } from 'components/RenewToken';
import { ReactNode, useRef, useState } from 'react';
import { IdleTimerProvider } from 'react-idle-timer';
import { signout } from './auth/userService';
import { config } from './config';

export default function App({ children }: { children: ReactNode }) {
  const { popupLogoutTime, totalIdleTime } = { ...config };
  const timeout = totalIdleTime - popupLogoutTime;

  const sessionTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <>
      <IdleTimerProvider
        timeout={timeout * 60 * 1000}
        onIdle={() => {
          !showModal && setShowModal(true);
          sessionTimeoutRef.current = setTimeout(
            logoutHandler,
            popupLogoutTime * 60 * 1000
          );
        }}
      >
        {children}
      </IdleTimerProvider>
      <RenewTokenModal
        isOpen={showModal}
        logoutHandler={logoutHandler}
        continueHandler={continueHandler}
      />
    </>
  );

  function logoutHandler() {
    sessionTimeoutRef.current && clearTimeout(sessionTimeoutRef.current);
    signout();
  }
  function continueHandler() {
    sessionTimeoutRef.current && clearTimeout(sessionTimeoutRef.current);
    setShowModal(false);
  }
}
